import { getMobilityRoute } from "./../api/mobility";
import { useQuery } from "@tanstack/react-query";
import { GetRouteParams } from "../types/types";

const useGetMobilityRoute = ({
  date,
  device_pid,
  second,
  seq,
}: GetRouteParams) => {
  const { data, isLoading } = useQuery({
    queryKey: [
      "MobilityRoute",
      `date-${date}`,
      `device_pid-${device_pid}`,
      `second-${second}`,
      `seq-${seq}`,
    ],
    queryFn: () => getMobilityRoute({ date, device_pid, second, seq }),
    staleTime: 0,
    // staleTime: 5 * 60 * 1000, // 5분
    // cacheTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false, // 테스트
    retry: false,
    enabled: !!device_pid,
  });

  return { data, isLoading };
};

export default useGetMobilityRoute;
